/**
 * P3-24: ZebraUpgradeButton —— Workshop 斑马升级按钮。
 *
 * 迁移自 `com.nuclearunicorn.game.ui.ZebraUpgradeButtonController` +
 * `BuildingResearchBtn`（js/workshop.js:3099-3135 / core.js:2327-2400）。
 *
 * 行为与 UpgradeButton 一致：已研究时 name 加 COMPLETE，受 hideResearched 控制。
 */
import { useCallback, type MouseEvent } from "react";
import { GameButton } from "../../components/GameButton";
import { useZebraUpgradeButtonModel } from "./useWorkshopModel";

interface ZebraUpgradeButtonProps {
  upgradeName: string;
}

export function ZebraUpgradeButton({ upgradeName }: ZebraUpgradeButtonProps) {
  const { snap, modelRef, controller, getTooltip } =
    useZebraUpgradeButtonModel(upgradeName);

  const onClick = useCallback(
    (event: MouseEvent) => {
      const model = modelRef.current;
      if (controller && model) {
        controller.buyItem?.(model, event);
      }
    },
    [controller, modelRef],
  );

  if (!snap || !snap.visible) {
    return null;
  }

  return (
    <GameButton
      name={snap.name}
      description={snap.description}
      enabled={snap.enabled}
      resourceIsLimited={snap.resourceIsLimited}
      getTooltip={getTooltip}
      onClick={onClick}
      getSelectedObject={() => modelRef.current}
    />
  );
}
